<template>
  <div class="qnr-intro-get-started card p-5 curved-border">
    <h1 class="title is-3 is-extra-bold">
      Get Started
    </h1>
    <div
      class="curved-border p-3 is-size-5 mb-6"
      :style="{borderColor: '#dfe2e7', borderWidth: '2px', fontWeight: 500}"
    >
      <div class="is-flex is-align-items-center mb-2">
        <i class="far fa-clock mr-3 base6Text " />
        <p>This will take less than 5 minutes.</p>
      </div>
      <div class="is-flex is-align-items-center mb-2">
        <i class="fas fa-lock mr-3 redText" />
        <div>
          <p>Your answers will remain private.</p>
          <p class="pl-2 is-size-7 has-text-weight-normal">
            Only you and {{ context.advisor_name }} will be able to see your answers
          </p>
        </div>
      </div>
      <div class="is-flex is-align-items-center mb-2">
        <i class="fas fa-save mr-3 base4Text " />
        <div>
          <p>Are your investments aligned with who you are?</p>
          <p class="pl-2 is-size-7 has-text-weight-normal">
            Questionnaire results can be used to assess your portfolio's alignment.
          </p>
        </div>
      </div>
    </div>
    <button
      v-if="!!startQtrCallbackFn"
      class="button is-primary is-fullwidth is-size-4 curved-border heavy"
      @click="startQtrCallbackFn"
    >
      Start questionnaire
    </button>
    <router-link
      v-else
      :to="{ name: 'institutional-qnr-section', params: { section: 1 }}"
    >
      <button class="button is-primary is-fullwidth is-size-4 curved-border heavy">
        Start questionnaire
      </button>
    </router-link>
  </div>
</template>


<script>
// import SubComponent from '../components/SubComponent'

export default {
  name: 'QnrIntroGetStarted',
  components: { /* Subcomponents */ },
  props: {
    context: {
      type: Object,
      required: true,
    },
    startQtrCallbackFn: {
      type: Function,
      required: false,
      default: null,
    },
  },
  data() {
    return {
    };
  },
  computed: { /*
      Creates a new property
      Updates when any dependant property changes */
  },
  watch: { /*
      Watches an existing property
      Only runs when the watched property changes */
  },
  beforeCreate() {},
  async created() {
  },
  mounted() {},
  updated() {},
  methods: {},
};
</script>


<style scoped>

</style>
